module.exports = __webpack_public_path__ + "e960c35b084d4cca84d4088b802c25d9.png";